import { APIConstructor } from '@knitiv/api-client-javascript';
import APIV5 from '~/models/api';
import KDate from '~/models/kdate';

export default class BaseComponent {
	/**
	 * @param {import('angular').IAttributes} $attrs
	 */
	constructor($attrs) {
		// @ts-ignore
		const api = new APIConstructor();

		api.setBackEndpoint(APIV5.instance.backEndpoint);
		api.setFileEndpoint(APIV5.instance.fileEndpoint);
		api.setToken(APIV5.instance.token);
		api.setFrontURL('');
		api.setFrontVersion('');

		this.API = api;
		this.API.use((
			/** @type {import('@knitiv/api-client-javascript').MiddlewareContextInput} */ request,
			/** @type {import('@knitiv/api-client-javascript').Next} */ next,
		) => {
			if ($attrs.kparamModule || $attrs.kparamWorkspace) {
				const newContext = request;

				const kparam = {
					module: 'default',
					// workspace: null,
					kdate: KDate.now().asString(),
					workspace: undefined,
				};

				if ($attrs.kparamModule) {
					kparam.module = $attrs.kparamModule;
				}

				if ($attrs.kparamWorkspace) {
					kparam.workspace = $attrs.kparamWorkspace;
				}

				// @ts-ignore
				newContext.body.kparam = kparam;
				return next(newContext);
			}
			return next(request);
		});
	}
}
